<template>
  <div class="no-role">暂无权限</div>
</template>
<script>
export default {
  computed: {
    roles() {
      return this.store.state.user.roles
    }
  }
}
</script>
<style lang="scss" scoped="">
  .no-role {
    font-size: 18px;
    margin: 100px;
    text-align: center;
  }
</style>
